import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { VersionApiService } from '@portal-core/general/services/version-api.service';

@Service()
export class VersionService {
  private readonly versionApiService = inject(VersionApiService);

  getVersionAndBuildDate$(): Observable<string> {
    return this.versionApiService.getVersionAndBuildDate$();
  }
}
